import { BenefitHandoverStateDTO } from '../../../../models/protection-compliance-handover-view.dto';
import { Subject } from 'rxjs';

export class ProtectionComplianceHandoverService {
  public benefitChange$ = new Subject();
  public handoverChange$ = new Subject();
}
